module.exports = __webpack_public_path__ + "img/ldorina.61fef294.jpg";